import React, { useState, useCallback, useRef, useEffect } from 'react';
import ButtonGroup from '@amzn/awsui-components-console/button-group';

const ChatCopyButton: React.FC<{ text: string }> = ({ text }) => {
	const [copied, setCopied] = useState(false);
	const [copyError, setCopyError] = useState(false);
	const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

	useEffect(() => {
		return () => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
			}
		};
	}, []);

	const handleCopy = useCallback(async () => {
		try {
			await navigator.clipboard.writeText(text);
			setCopied(true);
			setCopyError(false);
			if (timeoutRef.current) clearTimeout(timeoutRef.current);
			timeoutRef.current = setTimeout(() => setCopied(false), 2000);
		} catch {
			setCopyError(true);
			if (timeoutRef.current) clearTimeout(timeoutRef.current);
			timeoutRef.current = setTimeout(() => setCopyError(false), 2000);
		}
	}, [text]);

	return (
		<ButtonGroup
			ariaLabel="Message actions"
			variant="icon"
			items={[
				{
					type: 'icon-button',
					id: 'copy',
					iconName: copied ? 'status-positive' : copyError ? 'status-negative' : 'copy',
					text: copied ? 'Copied' : copyError ? 'Copy failed' : 'Copy',
				},
			]}
			onItemClick={({ detail }) => {
				if (detail.id === 'copy') {
					handleCopy();
				}
			}}
		/>
	);
};

export default ChatCopyButton;
